import styled from 'styled-components'
import WizrFlexLayout from '../WizrFlexLayout'
import WizrText from '../WizrText'

const RoundTag = styled.div<{ color: string }>`
  width: 48px;
  height: 48px;
  gap: 0px;
  border-radius: 50px;
  opacity: 0px;
  background-color: ${(props) => props.color}; /* Set background color dynamically */
  display: flex;
  justify-content: center;
  align-items: center;
`

const CustomerHealthRoundTag = ({ text,type }: any): JSX.Element => {

    const getSentimentColor = (text: number): string => {
        if (text >= 75) return '#22C55E'; // Green
        if (text >= 30) return '#FBBF24'; // Yellow
        return '#EF4444'; // Red
    };

    const getEscalationColor = (text: number): string => {
        if (text >= 20) return '#EF4444'; // Red
        if (text >= 5) return '#FBBF24'; // Yellow
        return '#22C55E'; // Green
    };

    const getResolutionColor = (text: number): string => {
        if (text >= 36) return '#EF4444'; // Red
        if (text >= 8) return '#FBBF24'; // Yellow
        return '#22C55E'; // Green
    };

    const getColorFromText = (text: number, type: string): string => {
        switch (type) {
          case 'sentiment':
            return getSentimentColor(text);
          case 'escalation':
            return getEscalationColor(text);
          case 'resolution':
            return getResolutionColor(text);
          case 'total_tickets':
            return getEscalationColor(text);
          case 'open_tickets':
            return getEscalationColor(text);
          default:
            return 'white';
        }
      };
  
  const tagColor = getColorFromText(text,type)
  return (
    <WizrFlexLayout background='white' flexDirection='row' justifyContent='flex-start' alignItems='center' style={{gap:"10px"}}>
      <RoundTag color={tagColor} style={{width:"54px"}}>
        <WizrText type='h5' textColor='#FFFFFF' style={{fontSize:"18px"}}>
          {text}
        </WizrText>
      </RoundTag>
      {type==='resolution'?<WizrText type='h5' textColor={tagColor}>hrs</WizrText>:<></>}
    </WizrFlexLayout>
  )
}
export default CustomerHealthRoundTag
